import React, { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, Search } from "lucide-react";

interface DeepInsightSearchBarProps {
  onInput: (query: string) => void;
  isLoading: boolean;
  className?: string;
  suggestions?: string[];
  placeholder?: string;
}

const DeepInsightSearchBar: React.FC<DeepInsightSearchBarProps> = ({
  onInput,
  isLoading,
  className,
  placeholder,
}) => {
  const [, setShowAbove] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (formRef.current) {
      const rect = formRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      setShowAbove(spaceBelow < 200); // Show above if less than 200px space below
    }
  }, []);

  const handleInput = (e: React.FormEvent<HTMLInputElement>) =>
    onInput(e.currentTarget.value);

  return (
    <div className="relative w-[300px]">
      <form
        ref={formRef}
        className={`w-full flex items-center bg-white border-gray-300 rounded-lg overflow-hidden h-12 ${
          className || ""
        } border`}
      >
        <div className="flex items-center w-full h-full bg-white">
          <Input
            ref={inputRef}
            className="flex-grow text-base px-6 h-full flex items-center border-none focus:ring-0 bg-transparent"
            placeholder={placeholder || "Search deep insight?"}
            onInput={handleInput}
          />
          <Button
            type="button"
            className="rounded-full bg-transparent text-sky-500 hover:bg-transparent p-2 aspect-square h-10 w-10 mr-2"
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
              <Search className="h-5 w-5" />
            )}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default DeepInsightSearchBar;
